let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2hKLN")).then(() => parcelRequire('4wFIg'));